import type { LocalStack } from "@pax/environments";

declare const __PAX_LOCAL_STACK__: LocalStack;

/** The local stack whose dev server built this page; the default stack in any deployed build. */
export const localStack: LocalStack = __PAX_LOCAL_STACK__;
